import type { SiteConfig } from './types';

declare const __ANALYTICS_URL__: string;

export function siteConfig(): SiteConfig | null {
  const script = currentScript();
  const siteId = script?.dataset.siteId ?? null;
  if (!siteId) {
    warn('missing data-site-id');
    return null;
  }

  return {
    siteId,
    collectUrl: script?.dataset.collect ?? defaultCollectUrl(script),
    timezone: script?.dataset.timezone ?? browserTimezoneFallback(),
    orgId: script?.dataset.orgId ?? null,
    locationId: script?.dataset.locationId ?? null,
    restaurantCountry: script?.dataset.country ?? null,
    restaurantCity: script?.dataset.city ?? null,
  };
}

function currentScript(): HTMLScriptElement | null {
  if (document.currentScript instanceof HTMLScriptElement) return document.currentScript;
  const scripts = document.querySelectorAll('script[data-site-id]');
  const last = scripts.item(scripts.length - 1);
  return last instanceof HTMLScriptElement ? last : null;
}

function defaultCollectUrl(script: HTMLScriptElement | null): string {
  if (script?.src) {
    try {
      return `${new URL(script.src).origin}/c`;
    } catch {
      // fall through
    }
  }
  return __ANALYTICS_URL__;
}

function browserTimezoneFallback(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

function warn(message: string): void {
  try {
    console.warn(`[mysite-analytics] ${message}`);
  } catch {
    // noop
  }
}
